'use client';

import { styled } from 'styled-components';
import SplitContentPanel from '@dvd/components/SplitContentPanel';
import SplitMediaPanel from '@dvd/components/SplitMediaPanel';
import type { TwoChildren, SplitMediaProps } from '@types';
import SplitGrid from '.';

type SplitStackedTextProps = SplitMediaProps & {
  /**
   * The two BaseText children to be displayed
   */
  children: TwoChildren;
};

const SplitStackedContentPanel = styled(SplitContentPanel)`
  & > :not(:first-child) {
    margin-top: ${({ theme }) => theme.spacing[4]};
  }
`;

const SplitStackedText = ({
  children,
  hashedId,
  imageAlt,
  imageHeight,
  imageSrc,
  imageWidth,
  mediaOrientation,
}: SplitStackedTextProps) => {
  return (
    <SplitGrid mediaOrientation={mediaOrientation}>
      {hashedId ? (
        <SplitMediaPanel hashedId={hashedId} />
      ) : (
        <SplitMediaPanel
          alt={imageAlt}
          height={imageHeight}
          src={imageSrc}
          width={imageWidth}
        />
      )}
      <SplitStackedContentPanel>{children}</SplitStackedContentPanel>
    </SplitGrid>
  );
};

export default SplitStackedText;
